module.exports = __webpack_public_path__ + "img/hook_PEWAG_WLHW_2.8a9dce3a.png";